// Firebase Auth エラーコード -> 日本語メッセージ
export const authErrorMessages = {
  'auth/invalid-email': 'メールアドレスの形式が不正です',
  'auth/user-not-found': 'ユーザーが存在しません',
  'auth/wrong-password': 'パスワードが違います',
  'auth/email-already-in-use': 'このメールアドレスは既に使用されています',
  'auth/weak-password': 'パスワードが脆弱です (6文字以上にしてください)',
  'auth/too-many-requests': '試行回数が多すぎます。しばらく待って再試行してください',
  'auth/network-request-failed': 'ネットワークエラーが発生しました',
  'auth/invalid-credential': '認証情報が無効です。メールアドレス / パスワードを確認してください',
};

export function mapAuthError(err) {
  if (!err) return '不明なエラー';
  const code = err.code || '';
  return authErrorMessages[code] || err.message || '処理に失敗しました';
}
